import { View } from "@/classes/inbox/View";
import { orderBy, query, Query, where } from "firebase/firestore";

export class ViewUnassigned extends View {
  constructor() {
    super("Nicht zugewiesen");
  }

  async getQuery(): Promise<Query> {
    return query(
      this.defaultQuery,
      where("operator", "==", null),
      orderBy("updated", "desc")
    );
  }
}
